import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  Collapse,
  Form,
  Input,
  Label,
  Button,
  FormFeedback,
  Modal,
  TabContent,
  TabPane,
  NavLink,
  NavItem,
  Nav,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { changeBackupInfoList, getBackupInfoList, saveBackupInfoList, setAdmDataManagementError } from "../../store/actions";
import PeriodBtn from "../../components/Filter/PeriodBtn";
import { useState } from "react";
import { cloneDeep, filter } from 'lodash';

function BackupInfo({ toggle, activeTab, isOpen, tabId }) {

  const dispatch = useDispatch();

  const { noticeStr, totalPage, backupInfoList } = useSelector(state => ({
    noticeStr: state.admDataManagement.noticeStrBackup,
    totalPage: state.admDataManagement.totalPageBackup,
    backupInfoList: state.admDataManagement.backupInfoList,
  }))

  const filterValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      submitType: "view",

      perPage: 20,
      curPage: 1,
      datePeriod: "",
      fromDate: "",
      toDate: "",
    },

    onSubmit: (values) => {

      console.log()

      let submitType = values["submitType"];

      if (submitType === "view") {
        const filterParam = {
          limit: values["perPage"],
          curPage: values["curPage"],
          fromDate: values.fromDate?.replace(/-/g, "") ?? "",
          toDate: values.toDate?.replace(/-/g, "") ?? "",
        };
        dispatch(getBackupInfoList(filterParam));
      } else if (submitType === "save") {
        const _backupInfoList = [];
        backupInfoList.forEach(info => {
          if (info.checked) {
            _backupInfoList.push(info);
            info.checked = false
          }
        });
        console.log(_backupInfoList)
        if (_backupInfoList.length > 0) {
          dispatch(saveBackupInfoList(_backupInfoList))
          dispatch(changeBackupInfoList(backupInfoList))
        } else {
          dispatch(setAdmDataManagementError("Please select a record!"));
        }
      }
    }
  })

  const [chkAllFlag, setChkAllFlag] = useState(false);
  const onInfoCheck = (chkIdx, value) => {
    let _backupInfoList = cloneDeep(backupInfoList);

    if (chkIdx == "chkAll") {
      setChkAllFlag(value);
      _backupInfoList = _backupInfoList.map((info, idx) => {
        info.checked = value;
        return info;
      })
    } else {
      if (chkAllFlag && !value) setChkAllFlag(false);
      _backupInfoList[chkIdx].checked = value
    }

    dispatch(changeBackupInfoList(_backupInfoList));
  }

  const onPageChange = (curPage, perPage) => {
    filterValidation.setFieldValue("submitType", "view");

    if (curPage) {
      // setCurPageInput(curPage);
      filterValidation.setFieldValue("curPage", curPage);
    } else {
      // setCurPageInput(1);
      filterValidation.setFieldValue("curPage", 1);
    }

    if (perPage) {
      filterValidation.setFieldValue("perPage", perPage);
    }

    filterValidation.handleSubmit(filterValidation.values);
  }

  return (
    <TabPane style={activeTab === tabId ? {display: "block"} : {display: "none"}} tabId={tabId}>
      <Row>
        <Col lg={12}>
          <Card>
            <Link onClick={toggle} className="text-dark" to="#">
              <div className="p-4">
                <Media className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-3">
                    <i className="uil uil-file-copy-alt text-primary h2"></i>
                  </div>
                  <div className="flex-grow-1 overflow-hidden">
                    <h5 className="font-size-16 mb-1">Data Management</h5>
                  </div>
                  <i className="uil uil-filter font-size-24 text-muted"></i>
                </Media>
              </div>
            </Link>
            <Collapse isOpen={isOpen}>
              <div className="p-4 border-top">
                <Row>
                  <label htmlFor="inscribedDate" className="col-md-1 col-form-label" style={{ paddingTop: '0px' }}>
                    Date
                  </label>
                  <div className="col-md-9">
                    <PeriodBtn
                      formik={filterValidation}
                    />
                  </div>
                </Row>
                <Row >
                  <Col md={2}>&nbsp;</Col>
                  <Col md={3}>&nbsp;</Col>
                  <Col md={3}>
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light col-md-5"
                      onClick={() => {
                        filterValidation.setFieldValue("curPage", 1);
                        filterValidation.setFieldValue("submitType", "view");
                        filterValidation.handleSubmit(filterValidation.values);
                      }}
                    >
                      Search
                    </button>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </Card>
        </Col>
      </Row>
      {
        noticeStr &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="text-muted mb-0">
                  <p style={{ whiteSpace: "pre" }}>
                    {noticeStr}
                  </p>
                </CardTitle>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
      {
        Array.isArray(backupInfoList) && backupInfoList.length > 0 &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardTitle className="text-muted mb-0">
                <Row className="mb-3" style={{paddingTop: "25px", paddingLeft: "30px"}}>
                  <span className="col-md-8 button-items">
                    <Button
                      type="button"
                      color="primary"
                      className="waves-effect waves-light col-md-2"
                      onClick={() => {
                        filterValidation.setFieldValue("submitType", "save");
                        filterValidation.handleSubmit(filterValidation.values);
                      }}
                    >
                      Save
                    </Button>
                  </span>
                </Row>
              </CardTitle>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table mb-0" style={{ width: "500px" }}>
                    <thead>
                      <tr>
                        <th style={{ verticalAlign: "middle", textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={chkAllFlag}
                            onClick={(e) => onInfoCheck("chkAll", e.target.checked)}
                          />
                        </th>
                        <th>Date</th>
                        <th>DB</th>
                        <th>NetHunt</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        backupInfoList.map((info, index) => {
                          return (
                            <tr key={info.chkDate}>
                              <td align="center" style={{ verticalAlign: "middle" }}>
                                <input type="checkbox"
                                  checked={info.checked}
                                  onClick={(e) => onInfoCheck(index, e.target.checked)}
                                />
                              </td>
                              <td style={{ verticalAlign: "middle" }}>{`${info.chkDate.substring(0, 4)}/${info.chkDate.substring(4, 6)}/${info.chkDate.substring(6, 8)}`}</td>
                              <td style={{ verticalAlign: "middle" }}>{info.db}</td>
                              {/* <td>{info.netHunt}</td> */}
                              <td>
                                <Input
                                  className="form-control"
                                  type="text"
                                  style={{ width: "100px" }}
                                  placeholder="Enter time"
                                  onChange={(e) => {
                                    let _backupInfoList = cloneDeep(backupInfoList);
                                    _backupInfoList[index].nethunt = e.target.value;
                                    dispatch(changeBackupInfoList(_backupInfoList));
                                  }}
                                  value={info.nethunt}
                                />
                              </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </Table>
                </div>
                <div className="d-flex justify-content-between" style={{ marginTop: "20px" }}>
                  <span className="d-flex align-items-center gap-2">
                    <label
                      htmlFor="perPage"
                    >
                      Entries per page
                    </label>
                    <div style={{ width: "100px" }}>
                      <select
                        className="form-select"
                        name="perPage"
                        onChange={e => { onPageChange(1, e.target.value); }}
                        value={filterValidation.values.perPage}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                  </span>
                  <span className="d-flex align-items-center gap-2">
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<<"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) - 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<"}
                      </Button>
                    </div>
                    Page{" "}
                    <strong>
                      {filterValidation.values.curPage} of {totalPage}
                    </strong>

                    <Input
                      type="number"
                      min={1}
                      style={{ width: 70 }}
                      max={totalPage}
                      name="curPage"
                      defaultValue={filterValidation.values.curPage}
                      value={filterValidation.values.curPage}
                      onChange={(e) => {
                        const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                        // setCurPageInput(_curPage, totalPage)
                        filterValidation.setFieldValue("curPage", _curPage);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                          onPageChange(_curPage, filterValidation.values.perPage);
                        }
                      }}
                    />
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) + 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(totalPage, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">>"}
                      </Button>
                    </div>
                  </span>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
    </TabPane>
  )
}

export default BackupInfo;